import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AnimatedSection from '../components/AnimatedSection';
import { Card, CardContent } from '../components/ui/card';
import ZohoFormEmbed from '../components/ZohoFormEmbed';

const SampleRequestPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24">
        {/* Hero Section */}
        <section className="py-8 lg:py-20 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-4xl mx-auto">
                <h1 className="text-3xl lg:text-5xl font-bold mb-3 lg:mb-6" style={{ color: '#214140' }}>
                  Request a Sample
                </h1>
                <p className="text-base lg:text-xl text-gray-600 leading-relaxed">
                  Experience the Cordflex® difference in your ICU. Request a free sample kit to see how
                  our innovative line management solution can transform your patient care workflow.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </section>

        {/* Form Section (Zoho Forms) */}
        <section className="py-8 lg:py-20" style={{ backgroundColor: '#DFEAF0' }}>
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <AnimatedSection animation="fade-up" disableOnMobile>
                <Card className="shadow-xl">
                  <CardContent className="p-2 sm:p-4">
                    <ZohoFormEmbed
                      form="SampleRequest"
                      perma="QYPe5fUmJvpxAcqsl1njuvS4zHVGk5Rkx-VPq-GSTno"
                      height="1921px"
                      title="Cordflex Sample Request"
                    />
                  </CardContent>
                </Card>
              </AnimatedSection>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-3xl mx-auto">
                <h2 className="text-3xl lg:text-4xl font-bold mb-6" style={{ color: '#214140' }}>
                  What's Included in Your Sample
                </h2>
                <div className="grid md:grid-cols-3 gap-8 mt-12">
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: '#8BBAB8' }}>
                      <span className="text-white font-bold text-2xl">1</span>
                    </div>
                    <h3 className="text-lg font-semibold mb-2">Cordflex Clip</h3>
                    <p className="text-gray-600">Try it in your ICU environment</p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: '#8BBAB8' }}>
                      <span className="text-white font-bold text-xl">📋</span>
                    </div>
                    <h3 className="text-lg font-semibold mb-2">Training Materials</h3>
                    <p className="text-gray-600">Quick start guide and best practices</p>
                  </div>
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" style={{ backgroundColor: '#8BBAB8' }}>
                      <span className="text-white font-bold text-xl">📞</span>
                    </div>
                    <h3 className="text-lg font-semibold mb-2">Follow-up Support</h3>
                    <p className="text-gray-600">Our team will check in on your experience</p>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default SampleRequestPage;